import { io } from "socket.io-client";
import { SOCKET_URL } from '../../../../config';

// Socket.IO expects https:// NOT wss://
// It handles the WebSocket upgrade automatically
const API_BASE_URL = SOCKET_URL;

let connectionStatus = 'connecting';
let connectionStatusListeners = [];
let connectionTimeout = null;

//console.log('🔄 CRM Chat: Initializing socket connection to /crm namespace...');
// Connect to the /crm namespace for CRM users to chat with customers
const socket = io(`${API_BASE_URL}/crm`, { 
  transports: ['websocket', 'polling'], // Allow both transports
  timeout: 10000, 
});

const updateConnectionStatus = (status) => {
  connectionStatus = status;
  //console.log('📡 CRM Chat: Connection status changed to:', status);
  connectionStatusListeners.forEach(listener => listener(status));
};

socket.on("connect", () => {
  //console.log("✅ CRM Chat: Connected to server (/crm namespace)");
  updateConnectionStatus('connected');
  if (connectionTimeout) {
    clearTimeout(connectionTimeout);
    connectionTimeout = null;
  }
  
  // Auto-join as CRM agent when connected
  // Try to get user from the 'user' object in localStorage first (which supports masquerading)
  let user = null;
  try {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      user = JSON.parse(userStr);
    }
  } catch (e) {
    console.error('Error parsing user from localStorage', e);
  }

  const staffId = user?.user_id || localStorage.getItem('user_id') || '1';
  const userName = user?.user_name || localStorage.getItem('user_name') || 'Staff';
  const department = parseInt(user?.department_id || localStorage.getItem('department_id') || '1');
  
  //console.log('🔐 CRM Chat: Auto-joining as CRM agent:', { staffId, userName, department });
  socket.emit('join', { 
    clientId: staffId, 
    userName: userName, 
    department: department,
    direction: 1, // Agent direction
    channel: staffId,
    client: 'agent'
  });
});

socket.on("connect_error", (error) => {
  //console.error("❌ CRM Chat: Connection error:", error);
  updateConnectionStatus('error');
});

socket.on("disconnect", (reason) => {
 // console.log("🔌 CRM Chat: Disconnected:", reason);
  updateConnectionStatus('disconnected');
});

// Export connection status utilities
export const getConnectionStatus = () => {
  try {
    if (socket && socket.connected) return 'connected';
  } catch (e) {
    // ignore if socket not initialized
  }
  return connectionStatus;
};

export const onConnectionStatusChange = (listener) => {
  connectionStatusListeners.push(listener);
  // Immediately notify the new listener of current authoritative status
  try {
    listener(getConnectionStatus());
  } catch (e) {
    console.error('Error in connection status listener', e);
  }
  // Return unsubscribe function
  return () => {
    connectionStatusListeners = connectionStatusListeners.filter(l => l !== listener);
  };
};

// Set a timeout to mark connection as error if it doesn't connect in time
connectionTimeout = setTimeout(() => {
  if (connectionStatus === 'connecting') {
    console.warn('CRM Chat socket connection timeout — marking status as error');
    updateConnectionStatus('error');
  }
}, 10000);

export default socket;
